import { shallowRef } from 'vue';
import { getTenantContext, setTenantTileAuth, setTenantTileCatalog } from '@/composables/useTenant';

/**
 * Stato reattivo condiviso per le credenziali CloudFront tile.
 *
 * - Letto da `generateMapLayers()` / `signTileUrl()` dentro computed Vue
 *   → qualunque computed che lo accede si ri-valuta al cambio credenziali.
 * - Scritto da `useTileAuthRefresh` dopo ogni refresh.
 */
// SSR modules are reused between requests. Maps are rendered as stubs there,
// so never retain a request's credentials in the server's module singleton.
export const tileAuthRef = shallowRef(import.meta.env.SSR ? null : getTenantContext().tileAuth);
export const tileCatalogRef = shallowRef(import.meta.env.SSR ? null : getTenantContext().tileCatalog);

export function syncTileAuthFromPage(page) {
    tileCatalogRef.value = setTenantTileCatalog(page?.props?.auth?.user?.id != null || page?.props?.auth?.is_public ? page.props.tile_catalog ?? null : null);
    const tileAuth = page?.props?.auth?.user?.id != null ? page.props.tile_auth : null;
    tileAuthRef.value = setTenantTileAuth(tileAuth);
    return tileAuthRef.value;
}
